import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { DdiziType } from '@kinderlabs-pos/shared-data-type';

export const exitAsync =
	(rootUrl: string) =>
	async ({
		storeId,
		ddiziId,
		posId,
	}: {
		storeId: number;
		posId: number;
		ddiziId: DdiziType['id'];
	}) =>
		(
			await posAxiosClient.put<DdiziType>(
				`${rootUrl}/ddizi/store/${storeId}/pos/${posId}/ddizi/exit`,
				null,
				{
					params: {
						id: ddiziId,
					},
				}
			)
		).data;
